var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"label white_line"},[_c('span',{staticClass:"ellipsis"},[_vm._v(_vm._s(_vm.title))]),_c('v-icon',{attrs:{"x-small":""},on:{"click":function($event){$event.stopPropagation();return _vm.action_UnselectEmployee.apply(null, arguments)}}},[_vm._v("mdi-close")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }